import { useEffect } from "react";

/** Per-route SEO: sets document title + meta description + OG/Twitter tags.
 * Values restore to site defaults handled by SiteMeta when absent. */
export function useSeo(title, description, { path, image } = {}) {
  useEffect(() => {
    if (title) document.title = title;
    const set = (selector, attr, value) => {
      if (!value) return;
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const m = selector.match(/\[(name|property)="([^"]+)"\]/);
        if (!m) return;
        el.setAttribute(m[1], m[2]);
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };
    set('meta[name="description"]', "content", description);
    set('meta[property="og:title"]', "content", title);
    set('meta[property="og:description"]', "content", description);
    set('meta[name="twitter:title"]', "content", title);
    set('meta[name="twitter:description"]', "content", description);
    if (path) {
      set('meta[property="og:url"]', "content", `https://destinytip.com${path}`);
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.rel = "canonical";
        document.head.appendChild(link);
      }
      link.href = `https://destinytip.com${path}`;
    }
    if (image) set('meta[property="og:image"]', "content", image);
  }, [title, description, path, image]);
}
